import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["countrySelect", "stateSelect", "stateWrapper"]
  static values = { subdivisions: Object }

  connect() {
    this.updateVisibility(this.currentCountryCode())
  }

  countryChanged() {
    const country = this.currentCountryCode()
    this.clearState()
    this.repopulateOptions(country)
    this.updateVisibility(country)
  }

  currentCountryCode() {
    return this.countrySelectTarget.value || ""
  }

  optionsFor(country) {
    if (!country) return []
    return this.subdivisionsValue[country] || []
  }

  repopulateOptions(country) {
    const select = this.stateSelectTarget
    while (select.options.length > 0) select.remove(0)

    const blank = document.createElement("option")
    blank.value = ""
    blank.text = ""
    select.add(blank)

    for (const [name, code] of this.optionsFor(country)) {
      const opt = document.createElement("option")
      opt.value = code
      opt.text = name
      select.add(opt)
    }

    // Reinitialise slim-select so the new options are picked up
    const slimController = this.application.getControllerForElementAndIdentifier(select, "slim-select")
    if (slimController) slimController.init()
  }

  clearState() {
    this.stateSelectTarget.value = ""
  }

  updateVisibility(country) {
    const hasOptions = this.optionsFor(country).length > 0
    this.stateWrapperTarget.hidden = !hasOptions
  }
}
